import { connect } from "react-redux";
import Header from "../Header/Header";
import Sidemenu from "../DesignSystem/Sidemenu/Sidemenu";

export default connect(
	(state) => ({}),
	{}
)(() => {
	return (
		<div className="dashboard-container">
			<Header />
			<div className="wrapper flex direction-row justify-content-between align-items-start">
				<Sidemenu />
				<div className="dashboard-content">Hostels</div>
			</div>
		</div>
	);
});
